/* eslint-disable react-hooks/exhaustive-deps */
import { Icon, Image, Box, Text, Flex, Heading, Link } from '@chakra-ui/react'
import AWS from 'aws-sdk'
import { usePubNub } from 'pubnub-react'
import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useCognitoSignIn } from '../../../hooks/login.hooks'
import { VIEW_MODE, LS_LOGIN_MODE } from '../login.util'
import {
	AUTH_LOGIN_MODE,
	AUTH_PAYLOAD,
	AUTH_SESSION_CHECK,
	AUTH_SESSION_DATA,
} from '../../../utils/constant'
import { useAuthContext } from '../../../context/auth.context'
import { loginConst } from '../../../utils/action.constant'
import { useHistory } from 'react-router'
import { setLocalAuthDetails, decryptData } from '../../../utils/common.util'
import Amplify, { Auth } from 'aws-amplify'
import { dataLayerTagManager } from '../../../containers/repository/repo.utils'
import greneLogo from '../../../assets/images/grene-logo.png'
import { BsPhoneVibrate } from 'react-icons/bs'
import { AiOutlineWindows } from 'react-icons/ai'
import { TfiEmail } from 'react-icons/tfi'
import { useDeepStreamContext } from '../../../context/deepstream.context'
import { QRcodeGlobal } from './../../globalComponents/QRcode/index'

export const QrCodeLogin = ({ setLoginViewMode }) => {
	const history = useHistory()
	const pubnub = usePubNub()
	const urlParams = useParams()
	const [loginChannel, setloginChannel] = useState(null)
	const [loginError, setLoginError] = useState(false)
	const { mutate } = useCognitoSignIn()
	const { dispatch } = useAuthContext()

	const {
		state: { ds },
	} = useDeepStreamContext()

	useEffect(() => {
		setloginChannel(Math.floor(100000 + Math.random() * 900000))
		Amplify.configure({
			Auth: {
				mandatorySignIn: true,
				userPoolId: process.env.REACT_APP_USER_POOL_ID,
				identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
				userPoolWebClientId: process.env.REACT_APP_WEB_NO_SECRETE_CLIENT_ID,
				region: process.env.REACT_APP_AWS_REGION,
			},
			Analytics: {
				disabled: true,
			},
		})

		// Auth.configure({
		//   mandatorySignIn: true,
		//   userPoolId: process.env.REACT_APP_USER_POOL_ID,
		//   identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
		//   userPoolWebClientId: process.env.REACT_APP_WEB_NO_SECRETE_CLIENT_ID,
		//   region: process.env.REACT_APP_AWS_REGION,
		// });

		return () => {
			setloginChannel('')
		}
	}, [])

	const onSetAwsConfig = ({ idToken }) => {
		// Set the region where your identity pool exists (us-east-1, eu-west-1)
		AWS.config.region = process.env.REACT_APP_AWS_REGION

		// Configure the credentials provider to use your identity pool
		AWS.config.credentials = new AWS.CognitoIdentityCredentials({
			IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
			Logins: {
				[`cognito-idp.ap-south-1.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`]:
					idToken.jwtToken,
			},
		})
	}

	const handleMessage = useCallback(data => {
		if (data && data.channel === loginChannel.toString()) {
			dispatch({ type: loginConst.LOGIN_IN_PROGRESS })
			const { message } = data
			try {
				if (!!message.trim().split('-')[1]) {
					const msg = message.trim().split('-')
					if (msg[1] === loginChannel.toString()) {
						setLogin(msg[0])
					}
				} else if (!!message) {
					const msg = message
					if (msg) {
						setLogin(msg)
						ds.event.emit(`${loginChannel.toString()}-response`, 'success')
					}
				} else {
					alert('Login Error')
				}
			} catch (e) {
				alert('Login Error')
			}
		}
	})

	useEffect(() => {
		if (!!loginChannel && Object.keys(urlParams).length > 0) {
			ds.event.subscribe(loginChannel.toString(), data => {
				console.log({ data })
			})
			pubnub.subscribe({ channels: [loginChannel.toString()] })
			const authData = decryptData(urlParams.params)
			setLogin(authData)
		}
	}, [loginChannel, urlParams])

	useEffect(() => {
		if (loginChannel && ds) {
			setLoginError(false)
			pubnub.addListener({ message: handleMessage })
			pubnub.subscribe({ channels: [loginChannel.toString()] })
			ds.on('error', function (error, event, topic) {
				console.log(error, event, topic)
			})
			ds.event.subscribe(loginChannel.toString(), data => {
				if (!!data) {
					console.log(data)
					handleMessage({ channel: loginChannel.toString(), message: data })
				}
			})
		}

		return () => {
			if (loginChannel) {
				if (ds) {
					ds.event.unsubscribe(loginChannel.toString(), data => {
						console.log(data)
					})
				}
				pubnub.unsubscribe({ channels: [loginChannel.toString()] })
			}
		}
	}, [loginChannel])

	const setLogin = authData => {
		localStorage.setItem(AUTH_PAYLOAD, authData)
		const auth = JSON.parse(atob(authData))
		mutate(auth, {
			onSuccess: data => {
				sessionStorage.setItem(AUTH_SESSION_CHECK, true)
				sessionStorage.setItem(AUTH_LOGIN_MODE, LS_LOGIN_MODE.QR)
				sessionStorage.setItem(AUTH_SESSION_DATA, JSON.stringify(data))
				dispatch({
					type: loginConst.LOGIN,
					payload: {
						...auth,
						...data,
					},
				})
				setLocalAuthDetails({
					account_id: auth.accountId,
					asset_id: auth.assetId,
					asset_token_auth: auth.encToken,
					asset_encryption_token_id: auth.encToken,
					organization_id: auth.organizationId,
					workforce_id: auth.workforceId,
				})
				onSetAwsConfig(data)
				history.push('/idcardscreen')
			},
			onError: error => {
				console.log('error', error)
				setLoginError(true)
				dispatch({
					type: loginConst.LOGIN_IN_FAILED,
					payload: {
						error,
					},
				})
			},
		})
	}

	return (
		<Box
			bg='white'
			boxShadow='0px 4px 4px rgba(0, 0, 0, 0.25)'
			borderRadius='20px'
			minW='28rem'
			padding='3em 0em'
			color='black'
		>
			<Flex
				flex={1}
				h='full'
				alignItems='center'
				justifyContent='center'
				flexDir='column'
				gap='1rem'
			>
				<Image src={greneLogo} maxW='64px' />
				<Heading fontWeight='900' fontSize='1.625rem' lineHeight='2.25rem'>
					Login Using GRID OS app
				</Heading>
				<Text fontWeight='500' fontSize='1rem' lineHeight='1.375rem'>
					Please open your app and scan the QR code
				</Text>
				{!!loginError ? (
					<Text fontWeight='400' size='sm' color='red.600' mt={5}>
						Login failed please try scanning again!
					</Text>
				) : null}
				<Box my={10} h='6rem' w='6rem'>
					<QRcodeGlobal
						style={{
							height: '100%',
							width: '100%',
						}}
						level='Q'
						value={`Desker-${loginChannel}`}
					/>
				</Box>
				<Box>
					<Link
						fontSize='0.875rem'
						variant='string'
						lineHeight='2.25rem'
						fontWeight='900'
						color='brand.700'
						display='flex'
						alignItems='center'
						onClick={() => {
							dataLayerTagManager('button_click', {
								viewName: 'Login',
								buttonName: 'Login via Email',
							})
							setLoginViewMode(VIEW_MODE.EMAIL)
						}}
					>
						<Icon as={TfiEmail} mr={4} w='1.375rem' h='1.375rem' />
						Login using Email
					</Link>
					<Link
						fontSize='0.875rem'
						variant='string'
						lineHeight='2.25rem'
						fontWeight='900'
						color='brand.700'
						display='flex'
						alignItems='center'
						onClick={() => {
							dataLayerTagManager('button_click', {
								viewName: 'Login',
								buttonName: 'Login via Phone',
							})
							setLoginViewMode(VIEW_MODE.OTP)
						}}
					>
						<Icon as={BsPhoneVibrate} mr={4} w='1.375rem' h='1.375rem' />
						Login using Phone
					</Link>
					{/* <Link
						fontSize='0.875rem'
						variant='string'
						lineHeight='2.25rem'
						fontWeight='900'
						color='brand.700'
						display='flex'
						alignItems='center'
						onClick={() => {
							setLoginViewMode(VIEW_MODE.ACTIVE_DIRECTORY)
						}}
					>
						<Icon as={AiOutlineWindows} mr={4} w='1.375rem' h='1.375rem' />
						Login using Active Directory
					</Link> */}
				</Box>
			</Flex>
		</Box>
	)
}
